/* eslint-disable sonarjs/cognitive-complexity */
import React, { FC, useMemo, useState, useEffect } from 'react'
import { ReservationObject, TheatricalReleaseObject, TheatricalShowtimeVenue } from '@/types/codegen-federation'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'
import { useTicketsContext } from '@/views/TicketCheckoutViews/ShowtimesView/components/TicketsContext'
import { BannerPlaceholder } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/BannerPlaceholder'
import ChangeReservationBanner from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/ChangeReservationBanner'
import { TicketPromoBanner } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/DiscountBanner/TicketPromoBanner'
import { isAngelIntegratedCountry } from '@/views/TicketCheckoutViews/ShowtimesView/utils/utils'
import { useGuildTickets } from '@/views/TicketCheckoutViews/hooks/useGuildTickets'

interface BannerSectionProps {
  reservation?: ReservationObject
  isEditReservationFlow: boolean
  theatricalRelease: TheatricalReleaseObject
  venues: TheatricalShowtimeVenue[]
}

const TicketBannerSection: FC<BannerSectionProps> = ({
  reservation,
  isEditReservationFlow,
  theatricalRelease,
  venues,
}) => {
  const { t } = useTranslate('tickets')
  const { isReady } = useSafeRouter()
  const { isFreeTicketPromo } = useTicketsContext()
  const countryCode = theatricalRelease?.region?.countryCode
  const { areGuildTicketsAvailable, loading: guildTicketsLoading } = useGuildTickets(theatricalRelease?.theatricalSlug)
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  }, [])

  const venuesWithShowtimes = useMemo(() => {
    return venues?.filter((venue) => venue?.showtimes?.length > 0)
  }, [venues])

  if (!isReady || venuesWithShowtimes?.length === 0) {
    return null
  }

  if (guildTicketsLoading && isClient) {
    return <BannerPlaceholder />
  }

  return (
    <>
      {!isEditReservationFlow && !isFreeTicketPromo && (
        <TicketPromoBanner
          theatricalSlug={theatricalRelease?.theatricalSlug}
          areGuildTicketsAvailable={areGuildTicketsAvailable}
          isGuildDataLoading={guildTicketsLoading}
          className="mb-4 rounded-xl !pr-0"
        />
      )}

      {reservation?.priorReservation?.id &&
        reservation?.isChangeReservation &&
        isAngelIntegratedCountry(countryCode) && (
          <ChangeReservationBanner
            description={t('pleaseSelectANewShowtimeBelow', 'Please select a new showtime below.')}
            priorReservation={reservation?.priorReservation}
            step={1}
          />
        )}
    </>
  )
}

export default TicketBannerSection
